import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EditNoteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"edit_note"}/>
}
